'use client';

import { ParsedUrlQuery } from 'querystring';

import { useEffect, useMemo, useState } from 'react';

import { useSearchParams } from 'next/navigation';

import Modal from '@components/Modal/next/Modal';
import Typography from '@components/Typography';
import { Row } from '@components/formStyles';
import { useDevice } from '@contexts/device';
import { useAuthState } from '@contexts/auth/AuthContext';
import { UserV2ViewModel } from '@api/v3';
import { paramsToObject } from '@components/views/utils';
import {
  getSafeLocalStorageItem,
  setSafeLocalStorageItem,
} from '@utils/localStorage/getSafeLocalStorage';
import { useAppRouter } from '@contexts/router';

import { ClubTag, ModalContent, StyledButton } from '../../style';

export const SeturExtraProExpiredModal = () => {
  const { isDesktop } = useDevice();
  const { loginInfo } = useAuthState<UserV2ViewModel>();
  const { push } = useAppRouter();
  const searchParams = useSearchParams();
  const query: ParsedUrlQuery = useMemo(() => {
    return paramsToObject(searchParams?.entries());
  }, [searchParams]);

  const isLoggedIn = Boolean(loginInfo?.token);

  const [showModal, setShowModal] = useState(false);
  const expiredClubs = loginInfo?.loyaltyUser?.customer?.customerClubSegments;

  useEffect(() => {
    // const { club_expired } = query;
    const isModalShown = getSafeLocalStorageItem('clubExpiredModalShown');
    const isModalShownControl = Boolean(
      getSafeLocalStorageItem('club_expired')
    );
    if (isLoggedIn && isModalShown === 'true' && !isModalShownControl) {
      setShowModal(true);
      getSafeLocalStorageItem('clubExpiredModalShown');
    } else {
      setShowModal(false);
    }
  }, [isLoggedIn, query]);

  const handleModalClose = () => {
    setShowModal(false);
    setSafeLocalStorageItem('clubExpiredModalShown', 'false');
    setSafeLocalStorageItem('club_expired', 'true');
  };
  const onClicked = () => {
    push(`/profil/indirim-kulupleri`);
    setShowModal(false);
    setSafeLocalStorageItem('clubExpiredModalShown', 'false');
    setSafeLocalStorageItem('club_expired', 'true');
  };
  return showModal ? (
    <Modal
      borderRadius={8}
      width={isDesktop ? 499 : '90vw'}
      height={isDesktop ? 'initial' : 300}
      contentStyles={{ minHeight: 300 }}
      padding={isDesktop ? '25px' : '12px 10px'}
      onCancel={handleModalClose}
      title={
        <Typography
          variant='Title4'
          color='D400'
          weight='SemiBold'
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          Özel Kulüp Üyelik Süreniz Doldu!
        </Typography>
      }
    >
      <ModalContent>
        <Typography
          variant='caption1'
          color='D200'
          weight='Regular'
          css={{ padding: '12px 10px' }}
        >
          Aşağıda bulunan özel kulüplere üyelik süreniz dolmuştur. Avantajlardan
          yararlanmaya devam etmek için yeniden katılım yapmanız gerekmektedir.
        </Typography>
        <Row style={{ margin: 0 }}>
          {expiredClubs?.map((club, index) => {
            return (
              <ClubTag key={index}>
                <Typography variant='caption1' color='D400' weight='SemiBold'>
                  {club.clubSegment}
                </Typography>
              </ClubTag>
            );
          })}
        </Row>
        <StyledButton
          onClick={onClicked}
          variant='Primary'
          style={{ alignSelf: 'center' }}
        >
          <Typography variant='caption' color='NL0' weight='Bold'>
            Yeniden Katıl
          </Typography>
        </StyledButton>
      </ModalContent>
    </Modal>
  ) : null;
};
